"use client";
import clsx from "clsx";
import { useState } from "react";
import {
  FieldError,
  FieldValues,
  Message,
  Path,
  PathValue,
  UseFormRegister,
  Validate,
  ValidationRule,
} from "react-hook-form";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const PasswordInput = <T extends FieldValues>({
  name,
  register,
  required,
  minLength,
  validationPattern,
  validation,
  error,
  placeholder,
  width = "350px",
}: {
  name: Path<T>;
  register: UseFormRegister<T>;
  required: Message | ValidationRule<boolean>;
  minLength?: number;
  validationPattern?: ValidationRule<RegExp>;
  validation?: Validate<PathValue<T, Path<T>>, T> | Record<string, Validate<PathValue<T, Path<T>>, T>> | undefined;
  placeholder: string;
  error?: FieldError;
  width?: string;
  type?: string;
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const colorClasses = error != null ? "bg-[#fdf2e1] border-attention" : "bg-input-normal border-input-normal";

  return (
    <>
      <div className={`w-[${width}] relative mb-1`}>
        <input
          id={name}
          {...register(name, { required, minLength, pattern: validationPattern, validate: validation })}
          className={clsx(
            `h-12 w-full  rounded border pl-4
          placeholder:text-input-placeholder
          focus:border-link focus:bg-link-light focus:shadow-input focus:outline-none focus:ring-link`,
            colorClasses
          )}
          placeholder={placeholder}
          type={showPassword ? "text" : "password"}
        />
        <div onClick={toggleShowPassword} className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3">
          {showPassword ? <FaEyeSlash /> : <FaEye />}
        </div>
      </div>
      {error != null && <p className="text-xs font-bold text-attention">{error.message}</p>}
    </>
  );
};

export default PasswordInput;
